/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_Passkey_Revoke_ActionInputs */



/**
* | output |
* | --- |
* | "Revoke" |
*
* @param {Profile_Security_Agent_Passkey_Revoke_ActionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_revoke_action = /** @type {((inputs?: Profile_Security_Agent_Passkey_Revoke_ActionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_Revoke_ActionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Widerrufen")
	return /** @type {LocalizedString} */ ("Revoke")
});